export const SERVICE_REVIEWS_CLASS = 'elc-review-detail-wrapper';
export const REVIEW_CATEGORY = 'service reviews';
